import { createAction, props } from '@ngrx/store';
import { IRiskMapping } from '../../models';

export const setSelectedRiskMapping = createAction('risk-mapping.selected.set', props<{ id: number }>());
export const clearSelectedRiskMapping = createAction('risk-mapping.selected.clear');

export const loadRiskMappings = createAction('risk-mappings.load');
export const loadRiskMappingsSuccess = createAction('risk-mappings.load.success', props<{ riskMappings: IRiskMapping[] }>());
export const loadRiskMappingsError = createAction('risk-mappings.load.error');
